var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldShowTrialPaywall
    ? _c("div", [_c("NuxPaywall", { attrs: { premiumPage: true } })], 1)
    : _c(
        "div",
        { class: { "success-page": true, mobile: _vm.isMobile(_vm.$mq) } },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "main",
            [
              _c("PaywallPlans", {
                attrs: { upgrade: _vm.paywall_type === "upgrade" }
              }),
              _vm._v(" "),
              _c("PageContent"),
              _vm._v(" "),
              !_vm.isMobile(_vm.$mq)
                ? _c("PaywallFooterCta", {
                    staticClass: "paywall-section",
                    attrs: { "cta-text": _vm.footerCtaText },
                    on: { "footer-cta-clicked": _vm.footerCtaClicked }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("PaywallGiftGroups", {
                class: ["paywall-section", { mobile: _vm.isMobile(_vm.$mq) }],
                attrs: { "group-plan": _vm.paywallPlans.groupPlan }
              }),
              _vm._v(" "),
              _vm.showReferAFriendModal
                ? _c("ReferAFriendModal", {
                    attrs: {
                      as: "referee",
                      "free-months-count": _vm.refereeDiscountData.free_months,
                      "referrer-name": _vm.refereeDiscountData.referrer_name
                    },
                    on: { close: _vm.closeReferAFriendModal }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "header-banner" }, [
      _c("h1", { staticClass: "page-title--seo" }, [_vm._v("Pricing")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }